module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/bot_button_ja.d60c7088.png";